/** Reads a File, downscales it to a max width, compresses to JPEG, and
 *  returns base64 without the `data:image/...;base64,` prefix — the shape
 *  the `analyze-image-vision` edge function expects. Resolves null on any
 *  read/decode failure so callers can handle it as a soft error. */
export const fileToCompressedBase64 = async (file: File, maxWidth = 1200): Promise<string | null> => {
  return new Promise((resolve) => {
    const reader = new FileReader();

    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== "string") {
        resolve(null);
        return;
      }

      const img = new Image();
      img.onload = () => {
        try {
          const scale = img.width > maxWidth ? maxWidth / img.width : 1;
          const targetWidth = img.width * scale;
          const targetHeight = img.height * scale;

          const canvas = document.createElement("canvas");
          canvas.width = targetWidth;
          canvas.height = targetHeight;

          const ctx = canvas.getContext("2d");
          if (!ctx) {
            resolve(null);
            return;
          }

          ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

          const dataUrl = canvas.toDataURL("image/jpeg", 0.7);
          const base64 = dataUrl.includes(",") ? dataUrl.split(",")[1] : dataUrl;
          resolve(base64);
        } catch (error) {
          console.error("[toBase64] Failed to compress image:", error);
          resolve(null);
        }
      };

      img.onerror = () => resolve(null);
      img.src = result;
    };

    reader.onerror = () => resolve(null);
    reader.readAsDataURL(file);
  });
};
